module.exports = __webpack_public_path__ + "au.no2.8dab3c4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/au.no2.jpg
// module id = Mue/
// module chunks = 0